<template>
  <!-- 참여하기 시작 -->
  <div class="widM txtC marTX padTX" style="border-top:1px solid #56565a">
    <p class="fntH3"><strong class="bolder">참여하기</strong></p>

    <!-- 참여하기 -->
    <div class="marTM padLS padRS padBX" style="border:5px solid #50b4b8;border-radius:18px;background-color:#f8ffff;overflow:hidden" id="register-step-page">
      <!-- 1차 신청 -->
      <template v-if="abo.step == 1">
      <p class="clearfix widS">
        <b class="fntH3 bold disBl marLS posRe" style="float:left;width:2.4em;height:2.4em;border-radius:0 0 2.4em 2.4em;background-color:#50b4b8;line-height:2.4em;color:#fff;top:-.3em">1차</b>
        <b class="fntH3 bold disBl txtL"><span class="disIb fntH4 posRe" style="left:.5em;top:.5em;color:#0e5259">2월 8일(화) 오전 10시 ~<br> 2월 13일(일) 자정(선착순)</span></b>
      </p>
      <div class="widS marTM">
        <div><img src="@/assets/images/relay-event/prod_01.png" alt="" class="icoL">
          <p class="fntH6">스킨 뉴트리션<br> 리뉴잉 포밍 클렌저 미니 (40 g) 증정</p>
          <p class="fntP light marTS">세안 후에도 당김없는 영양감을 선사하는<br class="moOnly"> 쫀쫀한 클렌저</p>
        </div>
      </div>
      </template>

      <!-- 2차 신청 -->
      <template v-if="abo.step == 2">
        <p class="clearfix widS">
          <b class="fntH3 bold disBl marLS posRe" style="float:left;width:2.4em;height:2.4em;border-radius:0 0 2.4em 2.4em;background-color:#50b4b8;line-height:2.4em;color:#fff;top:-.3em">2차</b>
          <b class="fntH3 bold disBl txtL"><span class="disIb fntH4 posRe" style="left:.5em;top:.5em;color:#0e5259">2월 15일(화) 오전 10시 ~<br> 2월 20일(일) 자정(선착순)</span></b>
        </p>
        <div class="widS marTM">
          <div><img src="https://www.amway.co.kr/_ui/_noticeImg/2022/01/0107_ev_skin_nutrition/prod_02.png" alt="" class="icoL">
            <p class="fntH6">스킨 뉴트리션<br> 리뉴잉 소프트닝 토너 미니(50 ml) 증정</p>
            <p class="fntP light marTS">즉각적인 보습과 윤기를 주는<br class="moOnly"> 진한 에센스 토너</p>
          </div>
        </div>
      </template>

      <!-- 3차 신청 -->
      <template v-if="abo.step == 3">
        <p class="clearfix widS">
          <b class="fntH3 bold disBl marLS posRe" style="float:left;width:2.4em;height:2.4em;border-radius:0 0 2.4em 2.4em;background-color:#50b4b8;line-height:2.4em;color:#fff;top:-.3em">3차</b>
          <b class="fntH3 bold disBl txtL"><span class="disIb fntH4 posRe" style="left:.5em;top:.5em;color:#0e5259">2월 22일(화) 오전 10시 ~<br> 2월 27일(일) 자정(선착순)</span></b>
        </p>
        <div class="widS marTM">
          <div><img src="https://www.amway.co.kr/_ui/_noticeImg/2022/01/0107_ev_skin_nutrition/prod_03.png" alt="" class="icoL">
            <p class="fntH6">스킨 뉴트리션<br> 리뉴잉 리액티베이션 크림 미니(15 g) 증정</p>
            <p class="fntP light marTS">맥문동, 강황 뿌리의 항산화력을 담아<br class="pcOnly"> 잃어버린 피부 탄력을 지켜주는 뿌리 에너지 크림</p>
          </div>
        </div>
      </template>


      <div class="marTM txtL widXS">
        <div class="row">
          <label class="col-xs-4 control-label" for="ev01_aboname"><b class="regular" style="font-size:14px;color:#56565a">이름</b></label>
          <div class="col-xs-8 col last-col">
            <input type="text" id="ev01_aboname" name="ev01_aboname" class="form-control" style="width:100%" maxlength="20" v-model="abo.abo_name" placeholder="이름을 입력하여 주세요.">
          </div>
        </div>
        <div class="row padTS">
          <label class="col-xs-4 control-label" for="ev01_abophone1"><b class="regular" style="font-size:14px;color:#56565a">핸드폰 번호</b></label>
          <div class="col-xs-8 col last-col">
            <input type="text" id="ev01_abophone1" name="ev01_abophone" class="form-control" style="width:28%;padding:0 10px" maxlength="3" v-model="abo.abo_phone1" placeholder="010" @keypress="NumbersOnly"> -
            <input type="text" id="ev01_abophone2" name="ev01_abophone" class="form-control" style="width:31%;padding:0 10px" maxlength="4" v-model="abo.abo_phone2" placeholder="0000" @keypress="NumbersOnly"> -
            <input type="text" id="ev01_abophone3" name="ev01_abophone" class="form-control" style="width:31%;padding:0 10px" maxlength="4" v-model="abo.abo_phone3" placeholder="0000" @keypress="NumbersOnly">                
          </div>
        </div>
        <div class="row padTS">
          <label class="col-xs-4 control-label" for="ev01_abonumber" style="padding-top:0"><b class="regular" style="font-size:14px;color:#56565a">ABO 번호<br>(또는 소비자 번호)</b></label>
          <div class="col-xs-8 col last-col">
            <input type="text" id="ev01_abonumber" name="ev01_abonumber" class="form-control" style="width:100%" maxlength="20" v-model="abo.abo_no" placeholder="ABO 번호 또는 소비자 번호"  >
          </div>
        </div>
        <div class="row padTSM">
          <div class="col-xs-12">
            <input id="ev01_checkagree01" type="checkbox" v-model="check_agree" @change="$emit('changeagree', check_agree)"><label for="ev01_checkagree01" class="normal inline-label checklabel">개인정보 수집, 이용 및 상기 이벤트 내용에 모두 동의합니다.</label>
          </div>
        </div>

        <!-- 버튼 영역 -->
        <div class="row padTSM">
          <div class="col-xs-12">
            <div class="osResBtnGrp">
                <button class="osResBtn01" @click="clickApply" style="cursor:pointer;background-color:#ec2020;border-radius:2em">선착순 이벤트 신청하기</button></div>
          </div>
        </div>
        <!-- //버튼 영역 -->
        
      </div>
    </div>
    <!-- //참여하기 끝 -->
  </div>
</template>

<script>
export default {
  name: 'apply_step1',
  props: ['state', 'agrees', 'abo'],
  data () { 
    return {
      abo_phone1 : '',
      abo_phone2 : '',
      abo_phone3 : '',
      check_agree: false
    }
  }, 
  computed: {
      isNone () {
          return (this.code != '')
      },
      isEventBefore () {
          return (this.code == 'before')
      },
      isEventClose () { 
          return (this.code == 'close')
      },
      isCompleted () { 
          return (this.code == 'success')
      },
      isDuplicate () { 
          return (this.code == 'duplicate')
      }
  }, 
  methods : {
    NumbersOnly : function (evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();;
      } else {
        return true;
      }
    }, 

    clickApply: function () {

      if (!this.agrees) {
        this.$emit('message', '개인정보 수집 동의를 해야만 참여가 가능합니다.',  '4')
        return;
      }

      if (!this.abo.abo_name) {
        this.$emit('message','이름을 입력하세요.', '4')
        return;
      } 

      if (!this.abo.abo_phone1 || !this.abo.abo_phone2 || !this.abo.abo_phone3) {
        this.$emit('message','휴대폰번호를 입력하세요.', '4')
        return;
      } 

      if (!this.abo.abo_no) {
        this.$emit('message','ABO번호를 입력하세요.', '4')
        return;
      } 

      if ( /(\D)+/gi.test(this.abo.abo_phone1) 
          ||  /(\D)+/gi.test(this.abo.abo_phone2) 
          ||  /(\D)+/gi.test(this.abo.abo_phone3)
          ) {
        this.$emit('message','휴대폰 번호는 숫자만 입력하여 주세요.', '4')
        return;
      }
      
      this.$emit('clickapply')
      
    }
  }
}

</script>


// WEBPACK FOOTER //
// src/views/nutrilite/relayevent/component/apply_step.vue